import { defineMessages } from 'react-intl';

export const eventTypeMessages = defineMessages({
    startEnableAcceptorsCommand: {
        id: 'start-enable-acceptors-command',
        defaultMessage: 'Start enable acceptors command',
    },
    stopEnableAcceptorsCommand: {
        id: 'stop-enable-acceptors-command',
        defaultMessage: 'Stop enable acceptors command',
    },
    startDisableAcceptorsCommand: {
        id: 'start-disable-acceptors-command',
        defaultMessage: 'Start disable acceptors command',
    },
    stopDisableAcceptorsCommand: {
        id: 'stop-disable-acceptors-command',
        defaultMessage: 'Stop disable acceptors command',
    },
    startClearCoinsCommand: {
        id: 'start-clear-coins-command',
        defaultMessage: 'Start clear coins command',
    },
    stopClearCoinsCommand: {
        id: 'stop-clear-coins-command',
        defaultMessage: 'Stop clear coins command',
    },
    startClearBanknotesCommand: {
        id: 'start-clear-banknotes-command',
        defaultMessage: 'Start clear banknotes command',
    },
    stopClearBanknotesCommand: {
        id: 'stop-clear-banknotes-command',
        defaultMessage: 'Stop clear banknotes command',
    },
    startReturnByNominalCommand: {
        id: 'start-return-by-nominal-command',
        defaultMessage: 'Start return by nominal command',
    },
    stopReturnByNominalCommand: {
        id: 'stop-return-by-nominal-command',
        defaultMessage: 'Stop return by nominal command',
    },
    startEmptyBanknoteValidatorRecycleBoxesCommand: {
        id: 'start-empty-banknote-validator-recycle-boxes-command',
        defaultMessage: 'Start empty banknote validator recycle boxes command',
    },
    stopEmptyBanknoteValidatorRecycleBoxesCommand: {
        id: 'stop-empty-banknote-validator-recycle-boxes-command',
        defaultMessage: 'Stop empty banknote validator recycle boxes command',
    },
    startAcceptAmountCommand: {
        id: 'start-accept-amount-command',
        defaultMessage: 'Start accept amount command',
    },
    stopAcceptAmountCommand: {
        id: 'stop-accept-amount-command',
        defaultMessage: 'Stop accept amount command',
    },
    startReturnAmountCommand: {
        id: 'start-return-amount-command',
        defaultMessage: 'Start return amount command',
    },
    stopReturnAmountCommand: {
        id: 'stop-return-amount-command',
        defaultMessage: 'Stop return amount command',
    },
    startTimeoutStopCommand: {
        id: 'start-timeout-stop-command',
        defaultMessage: 'Start timeout stop command',
    },
    stopTimeoutStopCommand: {
        id: 'stop-timeout-stop-command',
        defaultMessage: 'Stop timeout stop command',
    },
    startUpdateSettingsCommand: {
        id: 'start-update-settings-command',
        defaultMessage: 'Start update settings command',
    },
    stopUpdateSettingsCommand: {
        id: 'stop-update-settings-command',
        defaultMessage: 'Stop update settings command',
    },
    startGetValuesInDevicesMemoryCommand: {
        id: 'start-get-values-in-devices-memory-command',
        defaultMessage: 'Start get values in devices memory command',
    },
    stopGetValuesInDevicesMemoryCommand: {
        id: 'stop-get-values-in-devices-memory-command',
        defaultMessage: 'Stop get values in devices memory command',
    },
    startSynchronizationCommand: {
        id: 'start-synchronization-command',
        defaultMessage: 'Start synchronization command',
    },
    stopSynchronizationCommand: {
        id: 'stop-synchronization-command',
        defaultMessage: 'Stop synchronization command',
    },
    acceptAmountStoppedByTimerCommand: {
        id: 'accept-amount-stopped-by-timer-command',
        defaultMessage: 'Accept amount stopped by timer',
    },
    amountAccepted: {
        id: 'amount-accepted',
        defaultMessage: 'Amount accepted',
    },
    amountDispensed: {
        id: 'amount-dispensed',
        defaultMessage: 'Amount dispensed',
    },
    remainingAmountForReturn: {
        id: 'remaining-amount-for-return',
        defaultMessage: 'Remaining amount for return',
    },
    banknoteCollectedFromRecycleBox: {
        id: 'banknote-collected-from-recycle-box',
        defaultMessage: 'Banknote collected from recycle box',
    },
    banknoteCollectedByStopTimer: {
        id: 'banknote-collected-by-stop-timer',
        defaultMessage: 'Banknote collected by stop timer',
    },
    diffBetweenInMemoryAndDeviceNominalValuesCoinPayoutException: {
        id: 'diff-between-in-memory-and-device-nominal-values-coin-payout-exception',
        defaultMessage: 'Difference between in memory and device nominal values coin payout exception',
    },
    diffBetweenInMemoryAndDeviceNominalValuesBanknoteValidatorException: {
        id: 'diff-between-in-memory-and-device-nominal-values-banknote-validator-exception',
        defaultMessage: 'Difference between in memory and device nominal values banknote validator exception',
    },
    incompleteDispense: {
        id: 'incomplete-dispense',
        defaultMessage: 'Incomplete dispense',
    },
    unpaidCoinsAmountException: {
        id: 'unpaid-coins-amount-exception',
        defaultMessage: 'Unpaid coins amount exception',
    },
    overpaidAmountException: {
        id: 'overpaid-amount-exception',
        defaultMessage: 'Overpaid amount exception',
    },
    returnByNominalValidationException: {
        id: 'return-by-nominal-validation-exception',
        defaultMessage: 'Return by nominal validation exception',
    },
    returnByNominalNoPayoutDeviceFoundException: {
        id: 'return-by-nominal-no-payout-device-found-exception',
        defaultMessage: 'Return by nominal no payout device found exception',
    },
    clearNominalFromDeviceMemoryException: {
        id: 'clear-nominal-from-device-memory-exception',
        defaultMessage: 'Clear nominal from device memory exception',
    },
    synchronizeNominalException: {
        id: 'synchronize-nominal-exception',
        defaultMessage: 'Synchronize nominal exception',
    },
    getCoinSelectorDeviceMemoryException: {
        id: 'get-coin-selector-device-memory-exception',
        defaultMessage: 'Get coin selector device memory exception',
    },
    getBanknoteValidatorDeviceMemoryException: {
        id: 'get-banknote-validator-device-memory-exception',
        defaultMessage: 'Get banknote validator device memory exception',
    },
    openCoinHandlerException: {
        id: 'open-coin-handler-exception',
        defaultMessage: 'Open coin handler exception',
    },
    closeCoinHandlerException: {
        id: 'close-coin-handler-exception',
        defaultMessage: 'Close coin handler exception',
    },
    updateSettingsCommandException: {
        id: 'update-settings-command-exception',
        defaultMessage: 'Update settings command exception',
    },
    dispenseBanknoteException: {
        id: 'dispense-banknote-exception',
        defaultMessage: 'Dispense banknote exception',
    },
    dispenseCoinsException: {
        id: 'dispense-coins-exception',
        defaultMessage: 'Dispense coins exception',
    },
    stopDispenseValueException: {
        id: 'stop-dispense-value-exception',
        defaultMessage: 'Stop dispense value exception',
    },
    cashApiBackgroundServiceStopped: {
        id: 'cash-api-background-service-stopped',
        defaultMessage: 'Cash API background service stopped',
    },
    cashApiHealthCheck: {
        id: 'cash-api-health-check',
        defaultMessage: 'Cash API health check',
    },
    cashApiQueueWorkerStopped: {
        id: 'cash-api-queue-worker-stopped',
        defaultMessage: 'Cash API queue worker stopped',
    },
    cashApiQueueWorkerStarted: {
        id: 'cash-api-queue-worker-started',
        defaultMessage: 'Cash API queue worker started',
    },
    disabledBySettingsBanknoteValidatorException: {
        id: 'disabled-by-settings-banknote-validator-exception',
        defaultMessage: 'Disabled by settings banknote validator exception',
    },
    clearBanknotesCommandException: {
        id: 'clear-banknotes-command-exception',
        defaultMessage: 'Clear banknotes command exception',
    },
    emptyBanknoteValidatorRecycleBoxesException: {
        id: 'empty-banknote-validator-recycle-boxes-exception',
        defaultMessage: 'Empty banknote validator recycle boxes exception',
    },
    successfulPayment: {
        id: 'successful-payment',
        defaultMessage: 'Successful payment',
    },
    cancelledPayment: {
        id: 'cancelled-payment',
        defaultMessage: 'Cancelled payment',
    },
    processPaymentException: {
        id: 'process-payment-exception',
        defaultMessage: 'Process payment exception',
    },
    successfulReverse: {
        id: 'successful-reverse',
        defaultMessage: 'Successful reverse',
    },
    processReversePaymentException: {
        id: 'process-reverse-payment-exception',
        defaultMessage: 'Process reverse payment exception',
    },
    operationException: {
        id: 'operation-exception',
        defaultMessage: 'Operation exception',
    },
    cardApiBackgroundServiceStopped: {
        id: 'card-api-background-service-stopped',
        defaultMessage: 'Card API background service stopped',
    },
    cardApiQueueWorkerStarted: {
        id: 'card-api-queue-worker-started',
        defaultMessage: 'Card API queue worker started',
    },
    cardApiQueueWorkerStopped: {
        id: 'card-api-queue-worker-stopped',
        defaultMessage: 'Card API queue worker stopped',
    },
    cardApiHealthCheck: {
        id: 'card-api-health-check',
        defaultMessage: 'Card API health check',
    },
    initializePayment: {
        id: 'initialize-payment',
        defaultMessage: 'Initialize payment',
    },
    initializeReversal: {
        id: 'initialize-reversal',
        defaultMessage: 'Initialize reversal',
    },
    cardAccepted: {
        id: 'card-accepted',
        defaultMessage: 'Card accepted',
    },
    cardRejected: {
        id: 'card-rejected',
        defaultMessage: 'Card rejected',
    },
    cardPinCodeRequested: {
        id: 'card-pin-code-requested',
        defaultMessage: 'Card PIN code requested',
    },
    unknownEvent: {
        id: 'unknown-event',
        defaultMessage: 'Unknown event',
    },
    operationalErrorsChange: {
        id: 'operational-errors-change',
        defaultMessage: 'Operational errors change',
    },
    cashInsert: {
        id: 'cash-insert',
        defaultMessage: 'Cash insert',
    },
    cashDispense: {
        id: 'cash-dispense',
        defaultMessage: 'Cash dispense',
    },
    successfulCardTransaction: {
        id: 'successful-card-transaction',
        defaultMessage: 'Successful card transaction',
    },
    failedCardTransaction: {
        id: 'failed-card-transaction',
        defaultMessage: 'Failed card transaction',
    },
    successfulCardTransactionReversal: {
        id: 'successful-card-transaction-reversal',
        defaultMessage: 'Successful card transaction reversal',
    },
    failedCardTransactionReversal: {
        id: 'failed-card-transaction-reversal',
        defaultMessage: 'Failed card transaction reversal',
    },
    cancelOperation: {
        id: 'cancel-operation',
        defaultMessage: 'Cancel operation',
    },
    coreError: {
        id: 'core-error',
        defaultMessage: 'Core error',
    },
    listActiveStay: {
        id: 'list-active-stay',
        defaultMessage: 'List active stay',
    },
    retrieveActiveStay: {
        id: 'retrieve-active-stay',
        defaultMessage: 'Retrieve active stay',
    },
    cashInsertCoreError: {
        id: 'cash-insert-core-error',
        defaultMessage: 'Cash insert core error',
    },
    cashDispenseCoreError: {
        id: 'cash-dispense-core-error',
        defaultMessage: 'Cash dispense core error',
    },
    cardTransactionCoreError: {
        id: 'card-transaction-core-error',
        defaultMessage: 'Card transaction core error',
    },
    transferBanknotesFromRecycleBox: {
        id: 'transfer-banknotes-from-recycle-box',
        defaultMessage: 'Transfer banknotes from recycle box',
    },
    transferBanknotesFromRecycleBoxCoreError: {
        id: 'transfer-banknotes-from-recycle-box-core-error',
        defaultMessage: 'Transfer banknotes from recycle box core error',
    },
    stopEmptyBanknoteValidatorRecycleBoxesCommandAndSaveDate: {
        id: 'stop-empty-banknote-validator-recycle-boxes-command-and-save-date',
        defaultMessage: 'Stop empty banknote validator recycle boxes command and save date',
    },
    retrieveActiveStayByIdentifier: {
        id: 'retrieve-active-stay-by-identifier',
        defaultMessage: 'Retrieve active stay by identifier',
    },
    manualDispenseRequestedDenominations: {
        id: 'manual-dispense-requested-denominations',
        defaultMessage: 'Manual dispense requested denominations',
    },
    cashLevelsBeforeClear: {
        id: 'cash-levels-before-clear',
        defaultMessage: 'Cash levels before clear',
    },
    fiscalApiHealthCheck: {
        id: 'fiscal-api-health-check',
        defaultMessage: 'Fiscal API health check',
    },
    fiscalApiQueueWorkerStarted: {
        id: 'fiscal-api-queue-worker-started',
        defaultMessage: 'Fiscal API queue worker started',
    },
    fiscalApiQueueWorkerStopped: {
        id: 'fiscal-api-queue-worker-stopped',
        defaultMessage: 'Fiscal API queue worker stopped',
    },
    startCreateFiscalNoteCommand: {
        id: 'start-create-fiscal-note-command',
        defaultMessage: 'Start create fiscal note command',
    },
    stopCreateFiscalNoteCommand: {
        id: 'stop-create-fiscal-note-command',
        defaultMessage: 'Stop create fiscal note command',
    },
    stopCreateCardFiscalNoteCommand: {
        id: 'stop-create-card-fiscal-note-command',
        defaultMessage: 'Stop create card fiscal note command',
    },
    startGenerateDailyReport: {
        id: 'start-generate-daily-report',
        defaultMessage: 'Start generate daily report',
    },
    stopGenerateDailyReport: {
        id: 'stop-generate-daily-report',
        defaultMessage: 'Stop generate daily report',
    },
    createCashFiscalNoteException: {
        id: 'create-cash-fiscal-note-exception',
        defaultMessage: 'Create cash fiscal note exception',
    },
    createCardFiscalNoteException: {
        id: 'create-card-fiscal-note-exception',
        defaultMessage: 'Create card fiscal note exception',
    },
    generateDailyReportException: {
        id: 'generate-daily-report-exception',
        defaultMessage: 'Generate daily report exception',
    },
    sendFiscalDeviceStatus: {
        id: 'send-fiscal-device-status',
        defaultMessage: 'Send fiscal device status',
    },
    sendFiscalDeviceStatusException: {
        id: 'send-fiscal-device-status-exception',
        defaultMessage: 'Send fiscal device status exception',
    },
    issuingFiscalNoteCompleted: {
        id: 'issuing-fiscal-note-completed',
        defaultMessage: 'Issuing fiscal note completed',
    },
    issuingFiscalNoteFailed: {
        id: 'issuing-fiscal-note-failed',
        defaultMessage: 'Issuing fiscal note failed',
    },
});
